import {
    IconAddressBook,
    IconBrandLinkedin,
    IconCalendarEvent,
    IconCurrencyBitcoin,
    IconDeviceMobile,
    IconFileText,
    IconId,
    IconLink,
    IconMail,
    IconMapPin,
    IconMessage2,
    IconPhone,
    IconWallet,
    IconWifi,
} from '@tabler/icons-react';
import { BRAND_MARKS } from './qrBrandMarks';

/**
 * Icon shown next to each content type in the picker.
 *
 * Social types use their real brand mark in the brand colour; everything else
 * uses a Tabler line icon tinted to match the kind of data it carries.
 */
const TYPE_ICONS = {
    url: { Icon: IconLink, color: '#3D3833' },
    text: { Icon: IconFileText, color: '#6B635C' },
    email: { Icon: IconMail, color: '#D33A2C' },
    phone: { Icon: IconPhone, color: '#1E9E5E' },
    sms: { Icon: IconMessage2, color: '#2563EB' },
    wifi: { Icon: IconWifi, color: '#0F4C81' },
    vcard: { Icon: IconAddressBook, color: '#6D28D9' },
    mecard: { Icon: IconId, color: '#7C3AED' },
    location: { Icon: IconMapPin, color: '#E4572E' },
    event: { Icon: IconCalendarEvent, color: '#0F766E' },
    payment: { Icon: IconWallet, color: '#E2136E' },
    applink: { Icon: IconDeviceMobile, color: '#0F172A' },
    whatsapp: { mark: BRAND_MARKS.whatsapp },
    facebook: { mark: BRAND_MARKS.facebook },
    instagram: { mark: BRAND_MARKS.instagram },
    twitter: { mark: BRAND_MARKS.x },
    youtube: { mark: BRAND_MARKS.youtube },
    // LinkedIn has no Simple Icons mark (see qrBrandMarks), so it keeps a glyph.
    linkedin: { Icon: IconBrandLinkedin, color: '#0A66C2' },
    telegram: { mark: BRAND_MARKS.telegram },
    crypto: { Icon: IconCurrencyBitcoin, color: '#F7931A' },
};

export default function QrTypeIcon({ type, size = 20 }) {
    const entry = TYPE_ICONS[type];
    if (!entry) return null;

    if (entry.mark) {
        return (
            <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
                <path d={entry.mark.path} fill={entry.mark.hex} />
            </svg>
        );
    }

    const { Icon, color } = entry;
    return <Icon size={size} color={color} stroke={1.9} aria-hidden="true" />;
}
